import { Component, Inject, Input} from 'ng-metadata/core';
import { PrimolyticsService } from '../../../analytics/primolytics.service';
import { TemplateUtil } from '../../../nddUtils/templateUtil.service';
import { BarcodeSearchService } from './barcodeSearch.service';
import { preventStateReload } from '../../../infra/annotations';
import { getBackendSystem } from '../../../appConfig/appConfigForward';
import { getVid } from '../../../appConfig/appConfigForward';
import { STATE_NAMES } from '../../../primoExplore/primoExploreStates.module';
import { PagesTitlesService } from '../../../infra/accessibility/pagesTitles.service';

const INVALID_BARCODE_CHARACTERS_REGEX =/[\[\]\{\}<>]/g;

@Component({
    selector: "prm-barcode-search",
    templateUrl: 'components/search/searchBar/barcodeSearch/barcode-search.html',
})

export class PrmBarcodeSearch{

    private _barcode: string;
  
    constructor(private primolyticsService: PrimolyticsService,
                private barcodeSearchService: BarcodeSearchService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private pagesTitlesService: PagesTitlesService,
                private templateUtil: TemplateUtil){}

    ngOnInit(): void {
        let queryFromUrl=this.$location.search().barcode;
        if (queryFromUrl){
            this.barcode=queryFromUrl;
        }
    }

    public barcodeSearch(){ 
        if (this.barcode){          //search only if there's a search query 
            this.runBeacon('barcodeSearch');
            this.barcodeSearchService.barcodeSearchInProgress=true;
            this.barcodeSearchService.barcodeSearchHasNoResults=false;
            this.clearSearchParamsFromUrl();
            this.addBarcodeParamToUrl(this.barcode);
            let promise = this.barcodeSearchService.getPnxByBarcode(this.barcode);

            promise.then(
                (response)=>{         
                    let item = response.data;
                    if(getBackendSystem() !== 'suprima'){
                        item.context = this.getContext(item);
                    }
                    window.open(this.templateUtil.getFullDeepLinkAbsPath(item), "_self");
                },(error)=>{
                    this.barcodeSearchService.barcodeSearchInProgress=false;
                    const barcode = this.barcode;
                    this.barcodeSearchService.noResultsBarcodeSearchTerm = this.sanitizeBarcode(barcode) || '';
                    this.switchToSearchState();     //we do not want to stay in fulldisplay state when showing "No results found"
                    this.updatePageTitle();
                    console.error(error);
                    this.barcodeSearchService.barcodeSearchHasNoResults=true;  //to show a 'No records found" message in FE
                }
            );
        }
    }

    private runBeacon(operation) {
		this.primolyticsService.doBeaconReport({
			'p': 'search',
			'op': operation
		}, this.primolyticsService.getTimestamp());
	}

    public onClearSearchInput() {
        this.barcode = undefined;
        document.querySelector('#barcode_input_field').focus();
    }

    @preventStateReload
    private addBarcodeParamToUrl(barcodeParamValue: string) {
        this.$location.search('barcode', barcodeParamValue);
    }

    private getContext(item) {
        let recordId = item.pnx.control.recordid[0];
        let context = item.context;
        if (context === undefined){
            if (recordId.startsWith("TN_")) {
                context = "PC";
            }
            else {
                context = "L";
            }
        }
        return context;
    }

    @preventStateReload
    private clearSearchParamsFromUrl() {
        let searchParams= this.$location.search();
        searchParams.query=undefined;
        searchParams.tab=undefined;
        searchParams.search_scope=undefined;
        searchParams.sortby=undefined;
        searchParams.offset=undefined;
        searchParams.facet=undefined;
        this.$location.search(searchParams).replace();
    }

    private switchToSearchState() {
        if (this.$state.current.name === STATE_NAMES.FULL_DISPLAY){
            let stateName = STATE_NAMES.SEARCH;
            let params = {
                mode: 'advanced',
                searchType: 'barcode',
                barcode: this.barcode,
                vid: getVid(),
                lang: this.$translate.use()
            };
            this.$state.go(stateName, params, {notify: false});
        }
    }

    private updatePageTitle() {
        this.$translate('main.title')
        .then((translation) =>
            this.pagesTitlesService.setTitle(translation + ' - '+ this.barcode));
    }

    get barcode() {
        return this._barcode;
    }

    set barcode(value) {
        this._barcode = value;
    }

    private sanitizeBarcode(value: string): string {
        return (value || '').replace(INVALID_BARCODE_CHARACTERS_REGEX, '');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/barcodeSearch/barcodeSearch.directive.ts